import { forecastIsStale } from "@/lib/conditions/forecast-presentation";

export function ForecastStatus({ lastUpdated, isStale, scoreUnavailable, forecastIssuedLabel }: {
  lastUpdated?: string | null;
  isStale?: boolean;
  scoreUnavailable?: boolean;
  /** The nightly gap (lib/conditions/gap-forecast.ts): scores shown are the previous run's forecast. */
  forecastIssuedLabel?: string | null;
}) {
  if (!forecastIsStale(lastUpdated, isStale)) return scoreUnavailable ? <div role="status" className="mb-4 rounded-[12px] border border-amber-300 bg-amber-50 p-4 text-[13px] leading-relaxed text-amber-900">
    <p className="font-bold">Sport score unavailable</p>
    <p>The shared weather forecast is current. A current score and complete safety assessment for this sport are unavailable, so session recommendations are withheld.</p>
  </div> : null;
  if (forecastIssuedLabel) return <div role="status" className="mb-4 rounded-[12px] border border-amber-300 bg-amber-50 p-4 text-[13px] leading-relaxed text-amber-900">
    <p className="font-bold">Showing the previous forecast for today</p>
    <p>{forecastIssuedLabel}. Today&apos;s update has not arrived yet, so scores shown are that run&apos;s forecast for today, not today&apos;s score. The readings below are historical context, and session recommendations return with the next update.</p>
  </div>;
  const date = lastUpdated && Number.isFinite(Date.parse(lastUpdated))
    ? new Date(lastUpdated).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" })
    : null;
  return <div role="status" className="mb-4 rounded-[12px] border border-amber-300 bg-amber-50 p-4 text-[13px] leading-relaxed text-amber-900">
    <p className="font-bold">Current forecast unavailable</p>
    <p>{date ? `The last update was ${date}. ` : ""}The readings below are historical context. Current scores and session recommendations will return when fresh data is available.</p>
  </div>;
}
